// Body of the password-reset confirm view: the sealy AccountShell wrapping
// either the SetPasswordForm (valid link) as a native React field tree, or the
// invalid-link error copy. The intro / error copy was hardcoded English in the
// legacy template; the account email + invalid-state strings arrive as props.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountShell } from "../AccountShell";

type IProps = Immutable<templates.PasswordResetConfirmDocumentTemplate>;

export const PasswordResetConfirmBody = (props: IProps): React.JSX.Element => (
    <AccountShell
        hasNav={props.has_nav}
        sideNav={props.side_nav}
        title={props.content_title}
    >
        {props.valid_link ? (
            <div className="my-account-form">
                <p>
                    Enter a new password for{" "}
                    <span className="utility-page__text-blue">
                        {props.user_email}
                    </span>
                </p>
                <p>
                    Please enter your new password twice so we can verify you
                    typed it in correctly.
                </p>
                <form
                    id="password_reset_form"
                    className="js-kuid-form"
                    action={props.action_url}
                    method="post"
                >
                    <CSRFToken />
                    <FormFields
                        fields={props.fields}
                        field_labels={props.field_labels}
                        field_errors={props.field_errors}
                        non_field_errors={props.non_field_errors}
                    />
                    <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                        <input
                            type="submit"
                            className="button button--full-width"
                            value={props.submit_text}
                        />
                    </div>
                </form>
            </div>
        ) : (
            <>
                <h1>{props.invalid_heading}</h1>
                <p>{props.invalid_message}</p>
            </>
        )}
    </AccountShell>
);
